module.exports = __webpack_public_path__ + "img/myLocation.fb2618ba.svg";